import React from "react";
import BaseModal from "components/BaseModal";
import * as Styled from "../../styles";

interface ConfirmSaveModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSaving: boolean;
  mode: "ADD" | "EDIT";
}

function ConfirmSaveModal({
  open,
  onClose,
  onConfirm,
  isSaving,
  mode,
}: ConfirmSaveModalProps) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Salvar"
      cancellationText="Cancelar"
      confirmationText={isSaving ? "Salvando..." : "Sim, desejo salvar"}
      cancellationCallback={onClose}
      confirmationCallback={onConfirm}
    >
      <Styled.ModalContent>
        <Styled.ModalTypography variant="h6">
          Você tem certeza que deseja salvar as alterações?
        </Styled.ModalTypography>
        <Styled.ImportantNotice>
          <Styled.ModalInfoIcon />
          <Styled.ModalImportantText component="span">
            <Styled.ModalImportantTextBold component="span">
              Importante:
            </Styled.ModalImportantTextBold>{" "}
            {mode === "EDIT"
              ? "Os dados editados do provedor serão salvos sobre as informações antigas."
              : "O provedor será adicionado e estará disponível para uso."}
          </Styled.ModalImportantText>
        </Styled.ImportantNotice>
      </Styled.ModalContent>
    </BaseModal>
  );
}

export default ConfirmSaveModal;
